import { Player } from "./Player";
import { getVideoProvider } from "../utils";

/**
 * Append the "controls=0" param to a YouTube embed URL
 * (handles URLs that already contain a query string)
 */
const hideYouTubeControls = (url) => {
  const [baseUrl, queryString] = url.split("?");
  const params = new URLSearchParams(queryString);
  params.set("controls", "0");
  return `${baseUrl}?${params.toString()}`;
};

const VideoPlayer = ({ videoId }) => {
  const provider = getVideoProvider(videoId);

  if (provider === "youtube") {
    return (
      <div className="mx-4">
        <iframe
          width="100%"
          height="415"
          className="rounded-4"
          src={hideYouTubeControls(videoId)}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture;"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  if (provider === "vimeo") {
    return <Player videoId={videoId} />;
  }

  return (
    <div className="d-flex justify-content-center align-items-center py-5">
      <p className="fw-bold fs-5 text-center mb-0">Video no disponible</p>
    </div>
  );
};

export default VideoPlayer;
export { VideoPlayer };
